import type { ICollection } from '@/interfaces'
import { type Constructable, Factory } from '@/models/'

export class Collection<T> extends Array<T> implements ICollection<T> {
	typeConstructor: Constructable<T>

	constructor(ctor: Constructable<T>, items: T[]) {
		super()
		this.typeConstructor = ctor
		if (items) {
			this.addItems(items)
		}
	}

	public add(item?: T): T {
		if (!item) {
			const newItem: T = Factory.create(this.typeConstructor, {})
			item = newItem
		} else if (!(item instanceof this.typeConstructor)) {
			const newItem: T = Factory.create(this.typeConstructor, item)
			item = newItem
		}
		const pos = this.push(item)
		return this[pos - 1]
	}

	public addItems(items: T[]): T[] {
		items.forEach((item) => {
			if (item instanceof this.typeConstructor) {
				this.push(item)
			} else {
				this.add(item)
			}
		})
		return this
	}

	public remove(item: T): void {
		const index = this.customfindIndex(item)
		if (index > -1) {
			this.splice(index, 1)
		} else {
			throw new Error('Item not found in collection')
		}
	}

	public get(): T[] {
		return this
	}

	public reset(newItem: T, oldItem: T): void {
		const index = this.customfindIndex(newItem)
		if (index > -1) {
			this[index] = oldItem
		} else {
			throw new Error('Item not found in collection')
		}
	}

	private customfindIndex(item: T): number {
		return this.findIndex((element) => this.isEqual(element, item))
	}

	private isEqual(item1: T, item2: T): boolean {
		return JSON.stringify(item1) === JSON.stringify(item2)
	}
}
